import '../sass/styles.scss';
import 'slick-carousel/slick/slick.js';
import 'dropkickjs/dist/dropkick.js';
import AOS from 'aos/dist/aos.js';
import jarallax from 'jarallax/dist/jarallax.js';





$ = jQuery;

document.addEventListener('DOMContentLoaded', () => {

    const header = document.querySelector("header");

    window.addEventListener('scroll', () => (window.scrollY > 200) ? header.classList.add('reduce_header') :  header.classList.remove('reduce_header')  );

    window.addEventListener('resize', function(){
        document.querySelector("nav").classList.remove('show');
    });

    AOS.init({
        once: true,
    });

    const navigator = document.querySelector("nav");
    const navbtn = document.querySelector('.nav-btn');
    const close = document.querySelector(".close-menu"); 
    const out = document.querySelector("main");

    navbtn.addEventListener("click", function(){
        navigator.classList.add('show');
    });

    close.addEventListener("click", function(){
        navigator.classList.remove('show');
    });

    out.addEventListener("click", function(){
        navigator.classList.remove('show');
    });

    jarallax(document.querySelectorAll('[data-jarallax]'));

    $(".slider").slick({
		dots: true,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 4000,
		pauseOnHover: false
	});

    $('.slider2').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
		adaptiveHeight: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
            breakpoint: 1440,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
        ]
    });

    // Iniciar Slick tipologias
    $('.contentSlide').slick({
        dots: false,
        arrows: false,
        autoplay: false,
        fade: true,
        asNavFor: '#slide-0', // inicializamos con el primer slider
        adaptiveHeight: true,
        draggable: false,  // evita que se pueda arrastrar con el mouse
        swipe: false        // evita que se pueda deslizar en pantallas táctiles
    });

    // Inicializamos cada contenedor individual
    $('.slider3').each(function(){
        $(this).slick({
            dots: false,
            arrows: false,
            autoplay: false,
            fade: true,
            adaptiveHeight: true
        }).hide(); // los ocultamos inicialmente
    });

    // Mostrar solo el primero
    $('#slide-0').show();

    // ✅ Función para actualizar el estado de las flechas
    function updateArrowState() {
        let activeSlider = $('.slider3:visible');
        let totalSlides = activeSlider.find('.slick-slide').not('.slick-cloned').length;

        if (totalSlides > 1) {
            $('.carousel-arrows')
                .removeClass('disabled-arrows')
                .addClass('active-arrows');
        } else {
            $('.carousel-arrows')
                .removeClass('active-arrows')
                .addClass('disabled-arrows');
        }
    }

    // Flechas manuales - MODIFICADO para afectar solo al slider activo
    $(".carousel-arrows .left3").click(() => {
        let activeSlider = $('.slider3:visible');
        if(activeSlider.length > 0) {
            activeSlider.slick('slickPrev');
        }
    });

    $(".carousel-arrows .right3").click(() => {
        let activeSlider = $('.slider3:visible');
        if(activeSlider.length > 0) {
            activeSlider.slick('slickNext');
        }
    });

    // Control de nav manual
    $('.slider-nav .item').on('click', function(e) {
        e.preventDefault();
        let index = $(this).index();

        $('.slider-nav .item').removeClass('active');
        $(this).addClass('active');

        // Ocultar todos
        $('.slider3').hide();

        // Mostrar el correspondiente
        let currentSlide = $('#slide-' + index);
        currentSlide.show();

        // Reiniciar slick en ese slide (opcional si quieres resetear imagen interna)
        currentSlide.slick('refresh');

        // Mover contenido textual
        $('.contentSlide').slick('slickGoTo', index);

        // ✅ Actualizar flechas
        updateArrowState();
    });

    // Inicializar clase activa
    $('.slider-nav .item').eq(0).addClass('active');

    // Sincronizar nav cuando se cambia contenido
    $('.contentSlide').on('afterChange', function(event, slick, currentSlide){
        $('.slider-nav .item').removeClass('active');
        $('.slider-nav .item').eq(currentSlide).addClass('active');

        $('.slider3').hide();
        $('#slide-' + currentSlide).show();

        // ✅ Actualizar flechas
        updateArrowState();
    });

    // ✅ Verificar flechas al cargar la página

    updateArrowState();


    // anchors de navegación comportamiento de offset
    const navLinks = document.querySelectorAll("nav a");

    navLinks.forEach(link => {
        link.addEventListener("click", function(e) {
            const href = this.getAttribute("href");
            const target = this.getAttribute("target");
            
            // Si el enlace tiene target="_blank", permitir comportamiento normal
            if (target === "_blank") {
                return; // No hacer nada, dejar que se abra en nueva pestaña
            }
            
            // Si no es un enlace interno (no empieza con #), permitir comportamiento normal
            if (!href || !href.startsWith("#")) {
                return;
            }
            
            // Solo para enlaces internos (que empiezan con #)
            e.preventDefault(); // Prevenir el salto automático del anchor
    
            const targetId = this.getAttribute("href").slice(1); // Elimina el '#' es algo que es necesario para que funcione el offset 
            const targetElement = document.getElementById(targetId);
    
            if (targetElement) {
                const offset = 115; // Ajusta este valor según el alto de tu nav fijo
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
    
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
    
                // Cerrar el nav
                navigator.classList.remove('show');
            }
        });
    });
});
